<template>
  <div>
    <div class="header">
      <div class="header-con">
        <img class="header-logo" src="../assets/images/ic_logo.png"/>
        <p class="header-title">油满商家后台管理</p>

        <div class="header-right">
          <img class="header-avatar" :src="avatar"/>
          <el-dropdown
              placement="bottom"
              trigger="click"
              width="200"
              @command="handleCommand"
          >
            <div class="header-name-con">
              <p class="header-name">{{ name }}</p>
              <img class="header-label" src="../assets/images/ic_arrow_down.png"/>
            </div>
            <el-dropdown-menu style="width:100px;padding:0px" slot="dropdown">
              <el-dropdown-item
                  style="width:100px;padding:0px;text-align:center;color:#333333;font-size:12px">退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </div>
    </div>
    <div class="bottom">
      <div class="slider">
        <ul class="slider-list">
          <li
              class="slider-item"
              v-bind:class="[item.selected ? 'slider-item-active' : '']"
              v-for="(item, index) in sliderList"
              :key="item.id"
              v-on:click="onClickSlider(index)">{{ item.label }}
          </li>
        </ul>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%">
      <span>确定要退出登录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="onClickExit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import bus from "../main";

export default {
  name: 'Home',
  data() {
    return {
      sliderList: [
        {label: "数据看板", selected: false, router: "Data"},
        {label: "班结信息", selected: false, router: "ClassInfo"},
        {label: "加油订单管理", selected: false, router: "OilOrder"},
        {label: "商品订单管理", selected: false, router: "GoodsOrder"},
        {label: "油类型管理", selected: false, router: "OilType"},
        {label: "商城管理", selected: false, router: "Store"},
        {label: "财务管理", selected: false, router: "Finance"},
        {label: "油站管理", selected: false, router: "Station"},
        {label: "二维码管理", selected: false, router: "Code"},
        {label: "个人中心", selected: false, router: "User"}
      ],
      name: "",
      avatar: "",
      dialogVisible: false
    }
  },

  created() {
    let name = this.$router.history.current.name;
    if (name == "Home") {
      this.sliderList[0].selected = true;
      this.$router.push({name: "Data"});
    } else {
      this.sliderList.some((item) => {
        if (item.router == name) {
          item.selected = true;
          this.$router.push({name: name});
          return true;
        }
      });
    }
    this.refreshUser();

  },

  mounted() {
    bus.$off("HOME");
    bus.$on("HOME", () => {
      this.refreshUser();
    });
  },

  methods: {
    refreshUser: function () {
      let userInfo = localStorage.getItem("userInfo");
      if (userInfo && JSON.parse(userInfo)) {
        let userObj = JSON.parse(userInfo);
        this.name = userObj.name;
        this.avatar = userObj.avatar;
      } else {
        this.$router.push({name: "Login"});
      }
    },
    onClickSlider: function (index) {
      this.sliderList.map((item, listItem) => {
        item.selected = (index == listItem);
        if (item.selected) this.$router.push({name: item.router})
      });
    },
    handleCommand: function () {
      this.dialogVisible = true;
    },
    onClickExit: function () {
      this.dialogVisible = false;
      localStorage.setItem("userInfo", "");
      localStorage.setItem("token", "");
      this.$router.replace({name: "Login"});
    },
  }

}
</script>

<style>
.header {
  border-bottom: 1px solid #CCCCCC;
}

.header-con {
  clear: both;
  zoom: 1;
  width: 1200px;
  height: 75px;
  margin: 0 auto;
  overflow: visible;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

}

.header-logo {
  width: 140px;
  height: 50px;
}

.header-title {
  font-size: 24px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
}

.header-right {
  cursor: pointer;
  font-size: 16px;
  color: #333333;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-avatar {
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: #CCCCCC;
  margin-right: 18px;
  object-fit: cover;
}

.header-name-con {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-name {
  font-size: 16px;
  color: #333333;
  /* width: 100px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-label {
  margin-left: 8px;
}

.bottom {
  clear: both;
  zoom: 1;
  width: 1200px;
  margin: 0 auto;
  overflow: visible;
  display: flex;
  flex-direction: row;
}

.slider {
  width: 219px;
  min-height: 600px;
  border-right: 1px solid #CCCCCC;
  padding-top: 18px;
}

.slider-item {
  width: 200px;
  height: 50px;
  line-height: 48px;
  border: 1px solid #CCCCCC;
  border-radius: 6px;
  font-size: 16px;
  color: #666666;
  text-align: center;
  margin-bottom: 12px;
  cursor: pointer;
}

.slider-item-active {
  background: #CA3F3F;
  border: none;
  color: white;
  font-weight: bold;
}

.content {
  width: 980px;
  display: flex;
  flex-direction: column;
}

.home-right {
  width: 100%;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0;
  margin-top: 30px;
  padding-bottom: 50px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #FFBD17;
  color: #FFFFFF;
}
</style>
